var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5586 6.44531C10.7293 6.44531 10.0547 5.77066 10.0547 4.94141V0H2.36328C1.06017 0 0 1.06017 0 2.36328V19.6367C0 20.9398 1.06017 22 2.36328 22H14.3945C15.6976 22 16.7578 20.9398 16.7578 19.6367V6.44531H11.5586ZM3.52344 15.4688H6.64813C7.00408 15.4688 7.29266 15.7573 7.29266 16.1133C7.29266 16.4692 7.00408 16.7578 6.64813 16.7578H3.52344C3.16748 16.7578 2.87891 16.4692 2.87891 16.1133C2.87891 15.7573 3.16748 15.4688 3.52344 15.4688ZM2.87891 12.6758C2.87891 12.3198 3.16748 12.0312 3.52344 12.0312H12.9766C13.3325 12.0312 13.6211 12.3198 13.6211 12.6758C13.6211 13.0317 13.3325 13.3203 12.9766 13.3203H3.52344C3.16748 13.3203 2.87891 13.0317 2.87891 12.6758ZM12.9766 8.59375C13.3325 8.59375 13.6211 8.88233 13.6211 9.23828C13.6211 9.59423 13.3325 9.88281 12.9766 9.88281H3.52344C3.16748 9.88281 2.87891 9.59423 2.87891 9.23828C2.87891 8.88233 3.16748 8.59375 3.52344 8.59375H12.9766Z",
    fill: "#1885CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 4.94119C11.3438 5.05965 11.4401 5.15603 11.5586 5.15603H16.4705C16.3521 4.9367 16.1996 4.73754 16.0187 4.56598L11.8755 0.646289C11.7166 0.495948 11.5377 0.368336 11.3438 0.26709V4.94119H11.3438Z",
    fill: "#1885CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP13);
export default __webpack_public_path__ + "static/media/p13.14be763efc138dc324a8f6422a1806d2.svg";
export { ForwardRef as ReactComponent };